/* istanbul ignore file */
import React from 'react';
import { EmployeesInput } from 'domain/shared/employee';

const MenteesDropdown = (props: any) => {
  return (
    <EmployeesInput
      source="mentorshipInformation.mentees"
      label="Mentees"
      placeholder="Select mentees"
      multiple
      isClearable
      customMapper={(item: any) => ({
        value: item.alias,
        label: `${item.nameEn?.firstName ?? ''} ${item.nameEn?.lastName ?? ''}`,
      })}
      {...props}
    />
  );
};

export default MenteesDropdown;
